import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import Page from '../../components/Page';


import { __ } from '../../i18n';

@graphql(gql`mutation updateIntegration($updateIntegrationMutation: UpdateIntegrationInput!) {
  updateIntegration(input: $updateIntegrationMutation) {
    clientMutationId
  }
}`, {
  name: 'updateIntegration',
})

export default class IntegrationReportToggle extends Page {
  constructor(props) {
    super(props);
    const { integration } = props;

    this.state = { integration };
  }

  handleUpdateIntegration(id, onlyReport) {
    const request = {
      mutate: this.props.updateIntegration,
      input: 'updateIntegrationMutation',
      message: __('Integration was updated'),
    };
    request.mutate({
      variables: {
        updateIntegrationMutation: { id, onlyReport }
      }
    }).then(() => {
      const data = this.state.integration;
      data.onlyReport = onlyReport;
      this.setState(data);
    });
  }

  render() {
    const { integration } = this.state;
    return (
      <label>
        <Checkbox
          name="hasDate"
          checked={integration.onlyReport}
          onClick={(e, { checked }) => {
            this.handleUpdateIntegration(integration.dbId, checked);
          }}
          toggle
        />
      </label>

    );
  }
}
